import config from '@bingads-webui-component-legacy/config/index';
import state from '@bingads-webui-component-legacy/state/index';
import { BudgetSuggestionContainer } from './container';

/**
 * show budget landscape panel, and bind alll related actions including apply/cancel
 *
 * @param {Object} event - The backbone click event from where the quality score cell was clicked.
 * @param {Object} campaign - campaign entity that triggered this call, currently this status should only happen in campagin grid
 * @param {Object} grid - The grid where the call was triggered
 * @param {Object} serverContext -  Server Context
 * @param {Object} activity  - Activity logger.
 * @param {Object} newI18n - new I18n Localization component
 * @param {Object} instrumentation - instrumentation object
 * @returns {undefined}.
*/
export function openBudgetSuggestionDialog(event, campaign, grid, serverContext = null, activity = null, newI18n = {}, instrumentation = {}) {
  new BudgetSuggestionContainer({
    i18n: newI18n,
    campaign,
    campaignId: campaign.Id,
    campaignType: campaign.CampaignType,
    budget: campaign.Budget,
    currency: config.get('AccountCurrencyCode'),
    CustomerId: state.get('customer_id'),
    AcctId: state.get('account_id'),
    serverContext,
    activity,
    grid,
    instrumentation,
  });
}
